'use strict';

var DemandPostingToolbarDirective = function DemandPostingToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-posting-toolbar.html'),
    scope: {
      cogOptionsSet: '='
    }
  };
};
DemandPostingToolbarDirective.$inject = [];
module.exports = DemandPostingToolbarDirective;